import React from "react";
import { Button, Modal, Popover } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import CustomInput from "components/General/CustomInput";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";

const Representation = ({
  showModal,
  setShowModal,
  setAccessToken,
  setAppSecret,
  setAppId,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const ModalStyle = {
    padding: "45px",
    borderRadius: "15px",
    background: "var(--modal-surface)",
    overflow: "hidden",
  };
  return (
    <Modal
      open={showModal}
      bodyStyle={ModalStyle}
      footer={null}
      onCancel={() => setShowModal(false)}
      style={{ overflow: "hidden", borderRadius: "15px", padding: "0px" }}
    >
      <CustomInput
        label={
          <div className={styles.title}>
            {t("settings.102")}
            <Popover content={t("settings.92")} trigger="hover">
              <InfoCircleFilled />
            </Popover>
          </div>
        }
        placeholder={t("settings.103")}
        onChange={setAppId}
        style={{ margin: "25px 0px" }}
      />
      <CustomInput
        label={t("settings.108")}
        placeholder={t("settings.109")}
        onChange={setAppSecret}
        style={{ margin: "25px 0px" }}
      />
      <CustomInput
        label={t("settings.104")}
        placeholder={t("settings.105")}
        onChange={setAccessToken}
        style={{ margin: "25px 0px" }}
      />
      <div className={styles.row}>
        <Button
          className={`${styles.btn} ${styles.outlined}`}
          onClick={() =>
            window.open(
              "https://www.notion.so/Instagram-95b8d6704ca24616bc06a872f4e2be33",
              "_blank"
            )
          }
        >
          {" "}
          {t("settings.101")}{" "}
        </Button>
        <Button className={styles.btn} onClick={onSubmit}>
          {" "}
          {t("button.4")}{" "}
        </Button>
      </div>
    </Modal>
  );
};

export default Representation;
